export const SpendLimitActionType = {
	SET_SPEND_LIMIT: "SET_SPEND_LIMIT",
};
